/**
 * 章の説明として画面に出せるか。
 *
 * DB には「題 + 章」を機械的に流し込んだだけの説明 (「はじめての Python 章」)
 * が入っている章がある。題の言い直しにすぎず、読んでも何も増えないので
 * 出さない。DB の中身は書き換えず、表示の側で落とす。
 */

/** 空白と末尾の句読点を落として、見た目の違いで取りこぼさないようにする */
function normalize(text: string): string {
  return text
    .normalize("NFKC")
    .replace(/\s+/g, "")
    .replace(/[。.、,!！]+$/u, "")
    .toLowerCase();
}

/**
 * 画面に出す章の説明。中身が無いと判断したら undefined。
 * 空、題と同じ、題に「章」「の章」を足しただけ、のどれかは中身なしとみなす
 */
export function displayChapterDescription(
  title: string,
  description: string | null | undefined,
): string | undefined {
  const text = description?.trim();
  if (!text) return undefined;
  const d = normalize(text);
  // 記号だけ (「…」「—」) も中身なし
  if (!/[\p{L}\p{N}]/u.test(d)) return undefined;
  const t = normalize(title);
  if (d === t || d === `${t}章` || d === `${t}の章`) return undefined;
  return text;
}
